import { FC } from "react";
import CustomPopup from "../../components/CustomPopup/CustomPopup";
import { defaultEmptyFun } from "../../utils/helper";
import { Box, Button, Typography } from "@mui/material";
import CommonGifAnimation from "../../components/CustomGifAnimation/CommonGifAnimation";
import { Colors } from "../../styles/constant";
import { T_AnimationData } from "../../globalTypes/GlobalTypes";
import ExclamationMarkGif from "../../assets/gif/Exclamation_Mark.json";

interface Props {
  open: boolean;
  handleOpen: any;
  errorMessage?: string;
}

const CustomErrorPopup: FC<Props> = ({
  open = false,
  handleOpen = defaultEmptyFun,
  errorMessage = "",
}) => {
  return (
    <CustomPopup open={open} handleOpen={defaultEmptyFun}>
      <Box padding="1.5rem 1rem">
        <Box
          display="flex"
          justifyContent="center"
          flexDirection={"column"}
          textAlign={"center"}
          alignItems={"center"}
        >
          <CommonGifAnimation
            animationData={ExclamationMarkGif as T_AnimationData}
          />
          <Typography marginTop={"2rem"} variant="h3" color={Colors.textblack}>
            {errorMessage}
          </Typography>
          <Button
            fullWidth
            variant="contained"
            sx={{ marginTop: "1rem" }}
            onClick={() => handleOpen(false)}
          >
            Got it
          </Button>
        </Box>
      </Box>
    </CustomPopup>
  );
};

export default CustomErrorPopup;
